import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Typography, Paper, Box, CircularProgress, Alert } from '@mui/material';
import { adminApi } from '../services/adminApi';

export function AnalyticsDashboard() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['analytics'],
    queryFn: () => adminApi.getAnalytics(),
    refetchInterval: 60000,
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">Failed to load analytics: {String(error)}</Alert>;
  }

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Analytics Dashboard
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Real-time statistics from Azure PostgreSQL and Supabase
      </Typography>

      <Box sx={{ mt: 2, display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        <Paper sx={{ p: 3, bgcolor: '#e3f2fd', flex: '1 1 300px' }}>
          <Typography variant="h6" gutterBottom color="primary">
            Patient Inquiries
          </Typography>
          {data?.patientInquiries.map((item) => (
            <Box key={item.status} display="flex" justifyContent="space-between" mb={1}>
              <Typography textTransform="capitalize">{item.status}:</Typography>
              <Typography fontWeight="bold">{item.count}</Typography>
            </Box>
          ))}
          {data?.patientInquiries.length === 0 && (
            <Typography color="text.secondary">No data yet</Typography>
          )}
        </Paper>

        <Paper sx={{ p: 3, bgcolor: '#fff3e0', flex: '1 1 300px' }}>
          <Typography variant="h6" gutterBottom color="warning.dark">
            Moderation Queue
          </Typography>
          {Object.entries(data?.moderationQueue || {}).map(([status, count]) => (
            <Box key={status} display="flex" justifyContent="space-between" mb={1}>
              <Typography textTransform="capitalize">{status}:</Typography>
              <Typography fontWeight="bold">{count}</Typography>
            </Box>
          ))}
          {Object.keys(data?.moderationQueue || {}).length === 0 && (
            <Typography color="text.secondary">Not implemented yet</Typography>
          )}
        </Paper>

        <Paper sx={{ p: 3, bgcolor: '#f3e5f5', flex: '1 1 300px' }}>
          <Typography variant="h6" gutterBottom color="secondary">
            Consultations
          </Typography>
          {Object.entries(data?.consultationRequests || {}).map(([status, count]) => (
            <Box key={status} display="flex" justifyContent="space-between" mb={1}>
              <Typography textTransform="capitalize">{status}:</Typography>
              <Typography fontWeight="bold">{count}</Typography>
            </Box>
          ))}
          {Object.keys(data?.consultationRequests || {}).length === 0 && (
            <Typography color="text.secondary">No data yet</Typography>
          )}
        </Paper>
      </Box>
    </>
  );
}
